module.exports = __webpack_public_path__ + "static/media/保腎3.c29e349d.png";